module.exports = __webpack_public_path__ + "static/media/cf.1b78ddbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cf.svg
// module id = 82
// module chunks = 0